import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// Global error handler to catch module initialization errors
window.addEventListener('error', (event) => {
  console.error('Global error caught:', event.error);
  // Prevent blank screen by showing error message
  if (event.error && event.error.message && event.error.message.includes('Cannot access')) {
    const root = document.getElementById('root');
    if (root && !root.innerHTML.includes('Application Error')) {
      root.innerHTML = `
        <div style="padding: 2rem; font-family: system-ui, sans-serif;">
          <h1>Application Error</h1>
          <p>An error occurred during application initialization.</p>
          <p style="color: #666; font-size: 0.875rem;">${event.error.message}</p>
          <button onclick="window.location.reload()" style="margin-top: 1rem; padding: 0.5rem 1rem; background: #3b82f6; color: white; border: none; border-radius: 4px; cursor: pointer;">
            Reload Page
          </button>
        </div>
      `;
    }
  }
});

// Import App normally - if there's a TDZ error, the global error handler will catch it
import App from './App';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

